import { render, staticRenderFns } from "./AddNoteModal.vue?vue&type=template&id=0681f2de&"
import script from "./AddNoteModal.vue?vue&type=script&lang=js&"
export * from "./AddNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports